import { Box } from '@frontend/components';

export const AssistanceAvailableBackground = (props: {
  [x: string]: unknown;
}) => {
  const boxSize: number = props.boxSize ?? 22;
  return (
    <Box
      display="inline-flex"
      boxSize={boxSize}
      alignItems="flex-start"
      position="absolute"
      top={`calc(50% - ${boxSize / 4}rem)`}
      right={`-${boxSize / 4}rem`}
      flexShrink={0}
      pointerEvents="none"
      background="radial-gradient(50% 50% at 50% 50%, rgba(151, 59, 246, .25) 31.9%, rgba(151, 59, 246, 0) 100%)"
      {...props}
    />
  );
};
